import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import AnalyticsRoute from './AnalyticsRoute'
import RequireAuth from './RequireAuth'
import LoginContainer from './login/LoginContainer'
import LoginCallbackContainer from './login/LoginCallbackContainer'
import ShortcutContainer from './ShortcutContainer'
import { initializeLock } from '../actions/auth_actions'
import { CALLBACK_ROUTE, LOGIN_ROUTE } from '../constants/auth'

class Site extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    initializeLock(this.props.dispatch)
  }

  render () {
    return (
      <BrowserRouter>
        <Switch>
          <AnalyticsRoute path={LOGIN_ROUTE} component={LoginContainer} />
          <AnalyticsRoute path={CALLBACK_ROUTE} component={LoginCallbackContainer} />
          <AnalyticsRoute path='/insights/dl/:shortcutId' component={ShortcutContainer} />
          <Route component={RequireAuth} />
        </Switch>
      </BrowserRouter>
    )
  }
}

export default connect()(Site)
